import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { BatchDocumentStatus, BatchPopulatedDocument } from 'src/app/models/batch';
import { BatchService } from 'src/app/services/batch.service';
import { DocumentService } from 'src/app/services/document.service';
import { Paginator } from '../../models/paginator';
import { getDocumentStatus as computeDocumentStatus } from '../../helpers/document-status.helper';

export type BatchDocumentSort = { active: string, direction: 'asc' | 'desc' | '' };

@Component({
  selector: 'app-batch-documents',
  templateUrl: './batch-documents.component.html',
  styleUrls: ['./batch-documents.component.scss']
})
export class BatchDocumentsComponent {

  @Input() documents: BatchPopulatedDocument[] = [];
  @Input() pager: Paginator<BatchPopulatedDocument> = {
    docs: [],
    totalDocs: 0,
    limit: 10,
    offset: 0,
    page: 1,
  };
  @Input() selection = new SelectionModel<BatchPopulatedDocument>(true, []);
  @Output() selectionChange = new EventEmitter<SelectionModel<BatchPopulatedDocument>>();
  @Output() page = new EventEmitter<PageEvent>();
  @Output() sortChange = new EventEmitter<BatchDocumentSort>();

  displayedColumns: string[] = ['select', 'name', 'class', 'status', 'actions'];

  constructor(
    public batchService: BatchService,
    private documentService: DocumentService,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService
  ) {

  }

  hasPageSelection() {
    return this.documents.some(row => this.isSelected(row))
  }

  isSelected(row: BatchPopulatedDocument) {
    return this.selection.selected.map(doc => doc._id).includes(row._id)
  }

  isAllSelected() {
    return this.documents.every(row => this.isSelected(row));
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      const difference = _.differenceBy(this.selection.selected, this.documents, '_id')
      this.selection.setSelection(...difference)
      this.selectionChange.emit(this.selection);
      return;
    }
    this.selection.setSelection(...[...this.selection.selected, ...this.documents.filter(row => !this.isSelected(row))])
    this.selectionChange.emit(this.selection);
  }

  toggle(row: BatchPopulatedDocument) {
    if (this.isSelected(row)) {
      this.selection.setSelection(...this.selection.selected.filter(doc => doc._id !== row._id))
    } else {
      this.selection.setSelection(...[...this.selection.selected, row])
    }
    this.selectionChange.emit(this.selection);
  }

  onSortChange(event: any) {
    this.sortChange.emit(event);
  }

  async handlePage(event: any) {
    this.page.emit(event);
  }

  documentIcon(document: Document) {
    return this.documentService.icon(document);
  }

  toDocument(document: any) {
    this.router.navigate(['documents', document._id], {
      state: {
        from: "BATCH"
      }
    })
  }

  getDocumentStatus(document: BatchPopulatedDocument) {
    return computeDocumentStatus(document, this.translate);
  }
}
